import React from "react";
import { IAppealExpiryProps } from "../../model/interface";
import { AppealType } from "../../model/enum";
import ContentAppealExpiry from "./ContentAppealExpiry";

export default function AppealExpiry(props: IAppealExpiryProps) {
    return (
        <React.Fragment>
            {props.appealType === AppealType.Content &&
                <ContentAppealExpiry
                    policyViolated={props.policyViolated}
                    appealEligibilityPeriod={props.eligibilityPeriod} />
            }
        </React.Fragment>
    )
}